import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";


export default function UsersRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.User.Archive />
            </Route>
            <Route path={ `${ path }/page/:pageNum` } exact>
                <Pages.User.Archive />
            </Route>
            <Route path={ `${ path }/page/` } exact>
                <Pages.User.Archive />
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.User.Create />
            </Route>
            <Route path={ `${ path }/:userID` }>
                { ({ match }) => <Pages.User.Single match={ match } exact /> }
            </Route>
        </Switch>
    );

}